import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class DropExpoService {
    constructor(private http: Http) { }


    public item = new Subject<any>();
    items = this.item.asObservable();

    public delete = new Subject<any>();
    itemsdelete = this.delete.asObservable();

    /**
     * 
     * @param cupo 
     */
    agregarCupo(cupo: any) {
        this.item.next(cupo);
    };

    getCupos(): Observable<any> {
        return this.items;
    }

    /**
     * 
     * @param cupo 
     */

    eliminarCupo(cupo: any) {
        this.delete.next(cupo);
    };


    getDelete(): Observable<any> {
        return this.itemsdelete;
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/drag_expo/type-check/drop-area-type-check/dropExpo.service.ts